/**
 * 문의하기 페이지에 노출되는 공개 연락처 문구.
 * Create React App: 빌드 시점에 REACT_APP_* 가 번들에 고정됩니다. 값을 바꾼 뒤에는 재빌드가 필요합니다.
 */
export const CONTACT_SUPPORT_EMAIL =
  process.env.REACT_APP_CONTACT_SUPPORT_EMAIL?.trim() || 'support@investmentdiary.com';

export const CONTACT_OPERATING_HOURS =
  process.env.REACT_APP_CONTACT_OPERATING_HOURS?.trim() ||
  '평일 09:00 ~ 18:00 (주말 및 공휴일 제외)';

export const CONTACT_RESPONSE_TIME =
  process.env.REACT_APP_CONTACT_RESPONSE_TIME?.trim() || '영업일 기준 1~2일';
